import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Typography, Divider, message, Spin } from "antd";

import VariantsTable from "./VariantsTable";

import { getProductDetailsV2 } from "api/customApis";
import {
  ImageContainer,
  PriceTitle,
  InfoContainer,
  FileList,
  tansformModalData,
  SelectProductButton,
} from "./ModalHelpers";

const { Text } = Typography;

export default function ProductDetailsCreateModal({
  showModal,
  setShowModal,
  id,
  isSelected,
  handleProductSelection,
}) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    if (showModal) {
      getProductDetailsV2(id)
        .then((res) => {
          const data = tansformModalData(res.data);
          setModalData(data);
          setLoading(false);
        })
        .catch((e) => {
          message.error("Failed to fetch Product data");
          setLoading(false);
        });
    }
  }, [showModal, id]);

  const handleClose = () => {
    setShowModal(false);
    setModalData({});
  };

  const renderBody = () => {
    if (loading) return null;
    return (
      <Row>
        <Col span={17}>
          <ImageContainer
            images={modalData?.product_images}
            setImgLoaded={setImgLoaded}
            imgLoaded={imgLoaded}
            data={modalData}
          />
        </Col>

        <Col span={7}>
          <Row>
            <Text
              className="product-id"
              style={{
                fontFamily: "Avenir-Roman",
                marginBottom: "0.5rem",
                fontSize: 18,
              }}
            >
              {modalData?.product_id ? "ID: " + modalData?.product_id : ""}
            </Text>
          </Row>

          <PriceTitle data={modalData.priceTitle} />

          {modalData?.sub_category && (
            <Row>
              <Col span={8}>
                <Text style={{ fontSize: "16px", margin: 0 }} type="secondary">
                  {`Sub Category`}
                </Text>
              </Col>

              <Col span={15} offset={1}>
                <span
                  style={{
                    fontSize: "16px",
                    paddingTop: "4px",
                    //  overflowWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {modalData?.sub_category.split(',').join(', ')}
                </span>
              </Col>
            </Row>
          )}
          <InfoContainer data={modalData.productionDetails} />

          <Divider
            style={{
              margin: "0 0",
              marginTop: 10,
              border: "1px solid #E6E7E7",
            }}
          />
          <Row justify="space-between" style={{ padding: "1em 0" }}>
            <SelectProductButton
              isSelected={isSelected}
              handleProductSelection={handleProductSelection}
            />
          </Row>
          <Divider
            style={{
              margin: "0 0",
              marginBottom: 10,
              border: "1px solid #E6E7E7",
            }}
          />
          {!!modalData?.variants?.length &&
            modalData?.variants?.[0]?.attributes?.length > 0 && (
              <VariantsTable data={modalData.variants} />
            )}
          <br />
          <InfoContainer data={modalData.others} />
          <Divider
            style={{
              margin: "0 0",
              marginBottom: 10,
              border: "1px solid #E6E7E7",
            }}
          />
          <FileList data={modalData.others} />
        </Col>
      </Row>
    );
  };

  const renderLoader = () => {
    if (loading) {
      return (
        <Row style={{ height: "80vh" }} align="middle">
          <Col span={2} offset={11}>
            <Spin size="large" />
          </Col>
        </Row>
      );
    }
  };

  return (
    <Modal
      visible={showModal}
      destroyOnClose={true}
      footer={null}
      onCancel={handleClose}
      width={"90%"}
      centered
      bodyStyle={{ borderRadius: 80 }}
    >
      {renderLoader()}
      {renderBody()}
    </Modal>
  );
}
